export const APPLICATION = 'application';
export const EQUIPMENT = 'equipment';
export const RETRO = 'retro';
